import { apiGet, apiPost, CRM_API_URI } from "api";

const CrmCategory = {
  getAll: async () => {
    const data = await apiPost(`${CRM_API_URI}/api/client/dropdowns/category`);
    return data.Categories;
  },
};

export default CrmCategory;
